import jobDetails from './state/review-details-state';

const mutations = {
  updateJobDetails(state, { jobDetailsData }) {
    state.jobDetails = jobDetailsData;
  },
  updateCompletionPercentage(state, { completionPercentage }) {
    state.completionPercentage = completionPercentage;
  },
  updateReviewQuestions(state, { questions }) {
    state.questions = questions;
  },

  updateReviewAnswers(state, { answers }) {
    state.answers = answers;
  },

  updateReviewId(state, { reviewId }) {
    state.id = +reviewId;
  },

  resetReviewState(state) {
    state.questions = [];
    state.answers = [];
    state.jobDetails = jobDetails();
  },

  updateUnfinishedReviews(state, { unfinishedReviews }) {
    state.unfinishedReviews = unfinishedReviews;
  },
};

const {
  updateJobDetails,
  updateReviewQuestions,
  updateReviewId,
  updateReviewAnswers,
} = mutations;

export {
  updateJobDetails,
  updateReviewQuestions,
  updateReviewId,
  updateReviewAnswers,
};

export default mutations;
